import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
} from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function nativeLoad(_this__u8e3s4, url) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.native_1;
  var tmp0_safe_receiver = this_0.element_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    if (!(tmp0_safe_receiver instanceof HTMLImageElement))
      THROW_CCE();
    tmp0_safe_receiver.alt = _this__u8e3s4.description_1;
    tmp0_safe_receiver.onerror = (dyn, msg, a, b, c) => {
      _this__u8e3s4._state_1.set_state_wnfcx0_k$(Companion_getInstance().exception_iibuh2_k$(Exception().new_kotlin_Exception_hsqbop_k$('Failed to load image: ' + msg)));
      return Unit_instance;
    };
    tmp0_safe_receiver.onload = (it) => {
      _this__u8e3s4._state_1.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b(Unit_instance));
      return Unit_instance;
    };
    tmp0_safe_receiver.src = url == null ? '' : url;
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.elementToDo_1.add_utx5q5_k$((it) => {
      if (!(it instanceof HTMLImageElement))
        THROW_CCE();
      it.alt = _this__u8e3s4.description_1;
      it.onerror = (dyn, msg, a, b, c) => {
        _this__u8e3s4._state_1.set_state_wnfcx0_k$(Companion_getInstance().exception_iibuh2_k$(Exception().new_kotlin_Exception_hsqbop_k$('Failed to load image: ' + msg)));
        return Unit_instance;
      };
      it.onload = (it) => {
        _this__u8e3s4._state_1.set_state_wnfcx0_k$(_ReactiveState___init__impl__fvdp9b(Unit_instance));
        return Unit_instance;
      };
      var tmp0_elvis_lhs = url;
      it.src = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      return Unit_instance;
    });
  }
}
//region block: exports
export {
  nativeLoad as nativeLoad3gm9heja6i3t0,
};
//endregion

//# sourceMappingURL=RawImageView.commonHtml.js.mjs.map
